
// region JS Imports

// region External Modules
import { EventEmitter } from "events"
import $ from "jquery"
import Promise from "plugins/bluebird"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
// endregion External Modules

// region Private Modules
import Google_PageView from "app/tracking/google/page_view"
import Goals_track from "app/tracking/goals/track"
import FacebookPixel_Event from "app/tracking/facebook-pixel/event"

import Concierge_Timer from "app/concierge/timer"
import Contact_shared from "concepts/listings/contact/shared/index"
import Contact_Modal from "concepts/listings/contact/request/modal/index"
import Notifier from "app/notifier/index"

import {
  refreshAndUpdateComponentPromise,
} from "app/authentication/remote_state"

import {
  getContactInfoData,
  setContactInfoData,
} from "app/local_storages/contact_info_storage/index"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


import {
  get as get_user,
  ResultTypeEnums as GetUserResultTypes,
} from "app/resources/users/get/index"

import {
  get_one as get_one_listing,
  ResultTypeEnums as GetOneListingResultTypes,
} from "app/resources/listings/get_one/index"

import {
  create as create_user,
  ResultTypeEnums as CreateUserResultTypes,
} from "app/resources/users/create/index"

import {
  create as createListingContactRequests,
  ResultTypeEnums as createListingContactRequestResultTypes,
} from "app/resources/listing_contact_requests/create/index"

import {
  captureMessage,
  captureException,
} from "app/error_reporting/index"

import {
  isSignedIn,
} from "app/authentication/state"

import {
  isPresentString,
} from "app/utils/type_checking/index"

import {
  trackSignUp,
} from "app/authentication/tracking/index"

import {
  init as initBuildingFollowButtons,
} from "concepts/buildings/building_follow_button/index"

import {
  init as initNeighbourhoodFollowButtons,
} from "concepts/neighbourhoods/neighbourhood_follow_button/index"

import {
  init as listing_shortlist_button_init,
} from "concepts/listings/listing_shortlist_button/index"

import CityUpdateSubscriptionButton from "concepts/buildings/overseas_marketing/city_update_subscription/button/index"

import {
  init as CountryFollowButton_init,
} from "apps/spacious_website/components/countries/follow_button"


import I18n from "plugins/i18n-js"


const RejectionReasons = {
  ERROR_REPORTED:    "ERROR_REPORTED",
  OPERATION_ABORTED: "OPERATION_ABORTED",
}

interface Selector {
  main: JQuery
}
interface InputSelector {
  main: JQuery
}

class ListingContactButton extends EventEmitter {
  protected selector: Selector
  protected $el: JQuery
  protected listing_id: any

  constructor(selector: InputSelector){
    super()

    this.selector = Object.assign({}, selector)
    this.$el = $(this.selector.main)
    this.listing_id = this.$el.data("listing-id")

    this.bind_action()
  }


  protected bind_action(){
    this.$el.on("click", (e) => {
      this.onClick(e)
    })
  }

  protected onClick(e: Event) {
    e.preventDefault()

    const $clicked_button = this.$el

    if ($clicked_button.hasClass("cell--listings--contact--button--clicked")){
      return
    }

    Concierge_Timer.clearTimer()

    let tracking_container_name = ""
    if ($clicked_button.parents(".cell-listings-modals-basic-info").length > 0) {
      tracking_container_name = "/listing-modal"
    }
    else if ($clicked_button.parents(".listing-search-result--listings").length > 0) {
      tracking_container_name = "/listing-search-result-container-list-view"
    }

    Google_PageView.track(
      [
        "/fake-path",
        "/apps/spacious-web-app",
        `/pages/${Contact_shared.getPageElementForTracking()}`,
        `/components${tracking_container_name}`,
        "/contact-lister-button",
        "/events/click",
      ].join("")
    )

    const local_contact_info_data = getContactInfoData()

    const user_authentication_handle =
      local_contact_info_data.user_authentication_handle || local_contact_info_data.contact_email_address || ""
    const contact_email_address =
      local_contact_info_data.contact_email_address
    const contact_phone_number =
      local_contact_info_data.contact_phone_number

    if (contact_email_address == null ||
      !isPresentString(contact_email_address)) {

      // Not enough contact into
      this.showContactModal()
      return
    }

    import(
      "libphonenumber-js"
    )
    .then(({isValidNumber: isValidPhoneNumber}) => {
      get_user({
        authentication_handle: user_authentication_handle,
      })
      .then(({result_type, data}) => {
        switch (result_type) {
          case GetUserResultTypes.SUCCESS: {
            if (data == null) {
              throw RejectionReasons.OPERATION_ABORTED
            }

            const remote_contact_phone_number: null | string = data.contact_phone_number
            let final_contact_phone_number = contact_phone_number

            if (contact_phone_number == null ||
              !isPresentString(contact_phone_number) ||
              !isValidPhoneNumber(contact_phone_number)) {

              if (remote_contact_phone_number == null ||
                !isPresentString(remote_contact_phone_number) ||
                !isValidPhoneNumber(remote_contact_phone_number)) {

                this.showContactModal()
                throw RejectionReasons.OPERATION_ABORTED
              }

              setContactInfoData({
                contact_phone_number: remote_contact_phone_number,
              })
              final_contact_phone_number = remote_contact_phone_number
            }
            else {
              final_contact_phone_number = contact_phone_number
            }

            if (data.fast_contact_request_creation_enabled === false) {
              this.showContactModal()
              throw RejectionReasons.OPERATION_ABORTED
            }

            this._tryCreateListingContactRequests({
              user_authentication_handle: user_authentication_handle,
              contact_email_address:      contact_email_address,
              contact_phone_number:       final_contact_phone_number,
            })
            return
          }
          case GetUserResultTypes.RESOURCE_NOT_FOUND: {
            // no way to auto-fill, show modal
            this.showContactModal()
            throw RejectionReasons.OPERATION_ABORTED
          }
          // Pointless to show contact modal since unauthorized
          case GetUserResultTypes.UNAUTHORIZED: {
            Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.unauthorized"))
            throw RejectionReasons.OPERATION_ABORTED
          }
          case GetUserResultTypes.SERVER_ERROR: {
            Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.server_error"))
            throw RejectionReasons.OPERATION_ABORTED
          }
          default: {
            captureMessage(
              `unexpected/unhandled result_type: <${result_type}>`,
              Object.assign({
                source_file_path:
                  "app/assets/javascripts/concepts/listings/contact/button/events/index",
                authentication_handle:
                  user_authentication_handle,
              }),
            )
            throw RejectionReasons.ERROR_REPORTED
          }
        }
      })
      .catch((whatever) => {

        if (whatever === RejectionReasons.ERROR_REPORTED) { return }
        if (whatever === RejectionReasons.OPERATION_ABORTED) { return }

        if (whatever instanceof Error) {
          captureException(
            whatever,
            {
              source_file_path:
                "concepts/listings/contact/button/events/index",
            }
          )
          return
        }

        captureMessage(
          whatever.toString(),
          {
            source_file_path:
              "concepts/listings/contact/button/events/index",
          }
        )
      })
      .done()
    })
  }

  protected _tryCreateListingContactRequests({
    user_authentication_handle,
    contact_email_address,
    contact_phone_number,
  }: {
    user_authentication_handle: string,
    contact_email_address: string,
    contact_phone_number: string,
  }) {

    Promise.resolve()
    .then(() => {
      if (isSignedIn()) {
        return Promise.resolve()
      }

      return create_user({
        authentication_handle:  user_authentication_handle,
        email_address:          contact_email_address,
        sign_in_on_success:     true,
      })
      .then(({result_type}) => {
        switch (result_type) {
          case CreateUserResultTypes.SUCCESS:
            trackSignUp()
            refreshAndUpdateComponentPromise().done()
            return
          case CreateUserResultTypes.CONFLICT:
            return
          default:
            captureMessage(
              `unexpected/unhandled result_type: <${result_type}>`,
              {
                source_file_path:
                  "app/assets/javascripts/concepts/listings/contact/button/events/index",
              }
            )
            throw RejectionReasons.ERROR_REPORTED
        }
      })
    })
    .then(() => {
      return createListingContactRequests({
        user_authentication_handle: user_authentication_handle,

        listing_id: this.listing_id,

        listing_contact_request_attributes: {
          requester_email_address:
          contact_email_address,
          requester_phone_number:
          contact_phone_number,
        },
        reject_promotions: null,
      })
    })
    .then(({result_type, data}) => {
      if (result_type === createListingContactRequestResultTypes.LISTING_CONTACT_EMAIL_OR_PHONE_ABSENT) {
        this.showContactModal()
        throw RejectionReasons.OPERATION_ABORTED
      }

      // Pointless to show contact modal since unauthorized
      if (result_type === createListingContactRequestResultTypes.UNAUTHORIZED) {
        Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.unauthorized"))
        throw RejectionReasons.OPERATION_ABORTED
      }

      if (result_type === createListingContactRequestResultTypes.LISTING_EXPIRED) {
        Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.listing_expired"))
        throw RejectionReasons.OPERATION_ABORTED
      }

      // Since enquiry already sent
      // We prevent further enquiries to be created
      // And no modal shown
      if (result_type === createListingContactRequestResultTypes.CONFLICTING_RESOURCE_ALREADY_EXISTS) {
        Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.conflicting_resource_already_exists"))
        throw RejectionReasons.OPERATION_ABORTED
      }

      if (result_type === createListingContactRequestResultTypes.INVALID_CONTACT_PHONE_NUMBER) {
        Notifier.showError(I18n.t("app_resources.listing_contact_requests_create.errors.invalid_contact_phone_number"))
        throw RejectionReasons.OPERATION_ABORTED
      }


      if (result_type !== createListingContactRequestResultTypes.SUCCESS) {
        captureMessage(
          `unexpected result_type from createListingContactRequests: ${result_type}`,
          {
            source_file_path:
              "concepts/listings/contact/button/events/index",
            contact_email_address:
              contact_email_address,
            contact_phone_number:
              contact_phone_number,
          }
        )
        throw RejectionReasons.ERROR_REPORTED
      }

      return data
    })
    .then((data) => {
      this.setAsEnquirySent()

      get_one_listing({
        id: this.listing_id,
      })
      .then(({result_type, data: listing_data}) => {
        switch (result_type) {
          case GetOneListingResultTypes.SUCCESS: {
            if (listing_data == null) {
              captureMessage(
                `unexpected/unhandled null listing_data from "get_one_listing": <${result_type}>`,
                {
                  source_file_path:
                    "app/assets/javascripts/concepts/listings/contact/button/events/index.es6",
                }
              )
              throw RejectionReasons.ERROR_REPORTED
            }

            if (listing_data.is_for_serviced_office) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.SERVICED_OFFICE,
              )
              FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
              return
            }
            if (listing_data.is_for_coworking_space) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.COWORKING_SPACE,
              )
              FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
              return
            }
            if (listing_data.is_for_business_center) {
              // Fallback for other business center types
              // If there are other new types in the future
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.BUSINESS_CENTER,
              )
              FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
              return
            }
            if (listing_data.for_overseas_marketing_only) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.OVERSEAS,
              )
              FacebookPixel_Event.trackCustomEvent("OP-EmailEnquiry")
              return
            }
            if (listing_data.is_for_serviced_apartment) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.SERVICED_APARTMENT,
              )
              FacebookPixel_Event.trackCustomEvent("SACLS-EmailEnquiry")
              return
            }
            if (listing_data.is_for_coliving_space) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.COLIVING_SPACE,
              )
              FacebookPixel_Event.trackCustomEvent("SACLS-EmailEnquiry")
              return
            }

            if (listing_data.is_rental && !listing_data.is_commercial_listing) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.RESIDENTIAL_RENTAL,
              )
              FacebookPixel_Event.trackCustomEvent("RRRS-EmailEnquiry")
              return
            }
            if (!listing_data.is_rental && !listing_data.is_commercial_listing) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.RESIDENTIAL_SALE,
              )
              FacebookPixel_Event.trackCustomEvent("RRRS-EmailEnquiry")
              return
            }

            if (listing_data.is_rental && listing_data.is_commercial_listing) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.COMMERCIAL_RENTAL,
              )
              FacebookPixel_Event.trackCustomEvent("CRCS-EmailEnquiry")
              return
            }
            if (!listing_data.is_rental && listing_data.is_commercial_listing) {
              Goals_track.ListingContactByEmail.track(
                Goals_track.ListingContactByEmail.PropertyTypeLabels.COMMERCIAL_SALE,
              )
              FacebookPixel_Event.trackCustomEvent("CRCS-EmailEnquiry")
              return
            }

            break
          }
          default: {
            captureMessage(
              `unexpected/unhandled result_type from "get_one_listing": <${result_type}>`,
              {
                source_file_path:
                  "app/assets/javascripts/concepts/listings/contact/button/events/index.es6",
              }
            )
            throw RejectionReasons.ERROR_REPORTED
          }
        }
      })

      return Promise.resolve(
        import(
          "plugins/js-routes"
        )
      )
      .then((Routes) => {
        return q_ajax_3({
          url:      Routes.show_one_apps_spacious_website_partials_listing_contact_request_success_modals_path({
            locale:                     I18n.locale,
            listing_contact_request_id: data != null ? data.listing_contact_request_id : "-1",
          }),
          method:   "GET",
          dataType: "html",
        })
      })
    })
    .then(({data}) => {
      return Promise.resolve(
        import("app/modal/show-modal")
      )
      .then(({default: Modal}) => {
        Modal.hideTopModal()
        Modal.showModalWithContent(data)
        initNeighbourhoodFollowButtons()
        initBuildingFollowButtons()
        listing_shortlist_button_init().done()
        CityUpdateSubscriptionButton.init()
        CountryFollowButton_init().done()
      })
    })
    .catch((whatever) => {

      if (whatever === RejectionReasons.ERROR_REPORTED) { return }
      if (whatever === RejectionReasons.OPERATION_ABORTED) { return }

      if (whatever instanceof Error) {
        captureException(
          whatever,
          {
            source_file_path:
              "concepts/listings/contact/button/events/index",
          }
        )
        return
      }

      captureMessage(
        whatever.toString(),
        {
          source_file_path:
            "concepts/listings/contact/button/events/index",
        }
      )
    })
    .done()
  }

  protected setAsEnquirySent(){
    this.$el.addClass("cell--listings--contact--button--clicked")
  }

  protected showContactModal() {
    const listing_id =  this.$el.data("listing-id")

    q_ajax_3({
      url:      `/${I18n.locale}/listings/${listing_id}/contact_request`,
      method:   "GET",
      dataType: "html",
    })
    .then(({data}) => {
      return Contact_Modal.loadAndShowModal(data)
    })
    .done()
  }
}


const Factory = {
  create(selector: InputSelector){
    return new ListingContactButton(selector)
  },
}

export {
  Factory,
}
